'use strict';

const IsotopicDistribution = require('./IsotopicDistribution');

module.exports = IsotopicDistribution;



// WEBPACK FOOTER //
// ./node_modules/isotopic-distribution/src/index.js